import { c as _c } from "react/compiler-runtime";
import { OctarnalLogo } from "@/assets/icons/MainPageIcon";
import Link from "next/link";
const Logo = t0 => {
  const $ = _c(8);
  const {
    scrolled
  } = t0;
  const t1 = scrolled ? 28 : 36;
  const t2 = `transition-all duration-300 ease-in-out ${scrolled ? "h-8" : "lg:h-10 h-8"}`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <OctarnalLogo size={t1} className={t2} fill="#8EA71F" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `text-2xl font-black ${scrolled ? "hidden" : "text-[#8EA71F]"}`;
  let t5;
  if ($[3] !== t4) {
    t5 = <span className={t4}>Octarnal</span>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <div><Link href="/" className="flex items-center shrink-0 gap-1 focus:outline-none">{t3}{" "}{t5}</Link></div>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default Logo;